import { P2GBox } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { PanelButtons } from '../panels/PanelButtons';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  confirm?: () => void;
  cancel?: () => void;
  affected: number;
  justify: 'left' | 'center';
}

export default function Restore(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox textAlign={props.justify}>
      {props.affected === 1 ? (
        <P2GText>{t('RESTORE_ITEM_INFO', { defaultValue: 'Are you sure you want to restore this item?' })}</P2GText>
      ) : (
        <P2GText>
          {t('RESTORE_ITEM_INFO_ALTERNATIVE', { defaultValue: 'Are you sure you want to restore these items?' })}
        </P2GText>
      )}
      <P2GBox mt={1}>
        <PanelButtons
          centralise
          onSave={props.confirm}
          onCancel={props.cancel}
          cancelText={t('NO_CANCEL_BUTTON', { defaultValue: 'No' })}
          saveText={t('YES_BUTTON', { defaultValue: 'Yes' })}
        />
      </P2GBox>
    </P2GBox>
  );
}
